import React, { useEffect } from "react";
import { renderButton, renderTextField, renderCancelButton, renderCheckField, renderCheckFieldForcedValueArray} from "@/shared/FormUtils";
import { fetchAPI } from "@/utility/NetworkUtils";
import Loading from "@/shared/Loading";
import { Stack, Button } from "@mui/material";
import CreateNewItemSearchModal from "../CreateNewItemSearchModal";
const DeleteItemForm = ({
  formikProps,
  item,
  onClose,
  onSave
}) => {
  const [ upcomingEvents, setUpcomingEvents ] = React.useState(null);
  const [ submitting, setSubmitting ] = React.useState(false);
  const loading = upcomingEvents === null;

    
  const [ mergeModalOpen, setMergeModalOpen ] = React.useState(false);
  const [ mergingItem, setMergingItem ] = React.useState(null);
  
  useEffect(() => { 
    loadUpcomingEvents()
  }, [])

  const loadUpcomingEvents = async () => {
    fetchAPI(`/webapi/items/${item.id}/upcoming_events`, (json)=> {
      if (!json.errors) {
        setUpcomingEvents(json.events)
      }
    })
  }

  if(loading) {
    return (
      <Loading />
    )
  }

  const handleSave = () => {
    if(submitting) return
    setSubmitting(true)
    let body = {}
    console.log({
      v: formikProps.values
    })
    if(formikProps.values.delete_form_merge_with_existing_item) {
      body.merge_into = mergingItem.id
    }
    if(formikProps.values.delete_event) {
      body.remove_from_events = formikProps.values.delete_event
    }
    console.log({
      body
    })
    fetchAPI(`/webapi/items/${item.id}/`, (json) => {
      if(json.error) {
        alert(json.error)
      }else {
        //go back in history
        if(window.history.length > 1) {
         window.history.back()
        }else {
          window.location.href = "/"
        }
      }
    }, {
      method: "DELETE",
      body: body
    })
  }

  const renderButtons = () => {
    return (
      <Stack direction="row" spacing={2} justifyContent="flex-end" className="mt-4">
        {renderCancelButton("Cancel", onClose)}
        {renderButton(formikProps.values.delete_form_merge_with_existing_item ? "Merge & Delete" : "Delete Item", handleSave, {color:"pink", disabled: isSubmitDisabled()})}
      </Stack>
    )
  }

  const isSubmitDisabled = () => {
    return submitting || (formikProps.values.delete_form_merge_with_existing_item && !mergingItem)
  }

  const renderMergeItemSelect = () => {
    return (
      <>

        <div>
          <b>Currently Selected Item: {mergingItem ? mergingItem.name : "None"}</b>
        </div>
        <Button
          color="green"
          onClick={() => setMergeModalOpen(true)}
          variant="contained"
        > Select Item To Merge Into </Button>
        <CreateNewItemSearchModal
          renter={item.renter_id ? {id: item.renter_id} : {id: 'all'}}
          open={mergeModalOpen}
          onClose={() => setMergeModalOpen(false)}
          disableAddNewItem
          loadItems={true}
          onItemSelect={onMergeItemSelect}
          header={(
            <div>
            <h1>Merge This Item Into Another Item</h1>
              This will do the following 
              <ul>
                <li>Delete this item</li>
                <li>Move all inventory to the selected item</li>
                <li>Move all receiving items to the selected item</li>
                <li>Move all orders to the selected item</li>
              </ul>
            </div>
          )}
        />
      </>
    )
  }

  const onMergeItemSelect = (item) => {
    setMergingItem(item)
    setMergeModalOpen(false)
  }

  return (
    <div className="mt-[40px] text-black">
      <div className="text-black">
        <b>
          Warehouse only! Please contact warehouse personnel, if change is needed.
        </b>
        <br/>
        Deleting an item will remove the entire entry from the inventory.
        <br/>
        It will not remove the item from current or archived events.
        Instead the item will be flagged as 'Deleted'.
      </div>

      {(upcomingEvents||[]).length > 0 && (
        <div className="my-6 text-black">
          <div className="text-red-500 font-bold">
            Item is currently reserved for these upcoming events.
          </div>
          <div>
            Check the box if tyou want to remove the item hold for the event.
          </div>
          <div color="text-black">
          {upcomingEvents.map((event, index) => {
            return renderCheckFieldForcedValueArray(event.name, `delete_event`, event.id )
          })}
          </div>
        </div>
      )}

        <div className="mt-4">
          If you would like to merge this item with an existing item, please check below:
        </div>
        {renderCheckField("Merge with existing item", "delete_form_merge_with_existing_item", ['mb-0'])}
        {formikProps.values.delete_form_merge_with_existing_item && (
          renderMergeItemSelect(formikProps)
        )}
        {renderButtons()}
    </div>
  )
};

export default DeleteItemForm;